__turbopack_context__.v({
  "attribution": "dk8iTG_attribution",
  "card": "dk8iTG_card",
  "certifications": "dk8iTG_certifications",
  "compact": "dk8iTG_compact",
  "dates": "dk8iTG_dates",
  "detail": "dk8iTG_detail",
  "grid": "dk8iTG_grid",
  "image": "dk8iTG_image",
  "intro": "dk8iTG_intro",
  "label": "dk8iTG_label",
  "mark": "dk8iTG_mark",
  "name": "dk8iTG_name",
  "status": "dk8iTG_status",
  "verify": "dk8iTG_verify",
});
